import type { PolicyExtended } from '@/modules/ecom-policy/types'

import type { FormFields } from './types'

import type { Classification } from '../../new/types'

export const getInitialValues = (data: PolicyExtended) => ({
  name: data.name,
  description: data.description,
  // TODO: to be cleaned up when possible
  classificationList: (data.classificationList
    ? data.classificationList.split(',').map(classification => classification)
    : ['ALL']) as Classification[],
  messageToEmployee: data.messageToEmployee,
  stepMainDescription: data.stepMainDescription,
  stepAccessoriesDescription: data.stepAccessoriesDescription,
  minimumAmount: data.minimumAmount,
  maximumAmount: data.maximumAmount,
  coverAmount: data.coverAmount || 0,
  isManagerApprovalRequired: Boolean(data.isManagerApprovalRequired),
  isCustomAddressActivated: Boolean(data.isCustomAddressActivated),
  hasVat: Boolean(data.hasVat),
  isAssetReturnRequired: Boolean(data.isAssetReturnRequired),
  isActive: Boolean(data.isActive),
  isBuyoutAllowed: Boolean(data.isBuyoutAllowed),
  paymentInterval: data.paymentInterval,
  coverInterval: data.coverInterval,
  orderInterval: data.orderInterval,
  isRelationsIgnored: Boolean(data.isRelationsIgnored),
  isAdminRestricted: Boolean(data.isAdminRestricted),
  adminOverwriteUserId: data.adminOverwriteUserId,
  greenpoolTypeId: data.greenpoolTypeId || '',
  greenpoolConfirmationText: data.greenpoolConfirmationText || '',
  greenpoolSplashText: data.greenpoolSplashText || '',
  greenpoolNotificationEmail: data.greenpoolNotificationEmail || '',
  stepGreenpoolDescription: data.stepGreenpoolDescription,
  coverAmountInit: data.coverAmountInit || 0,
  isManagerAccessible: Boolean(data.isManagerAccessible),
  isLeasing: Boolean(data.isLeasing),
})

export const getPayload = (formValues: FormFields, isAdmin: boolean) => {
  // todo: use snakecasing in the fetcher instead
  const payload = {
    name: formValues.name,
    description: formValues.description,
    message_to_employee: formValues.messageToEmployee,
    step_main_description: formValues.stepMainDescription,
    step_accessories_description: formValues.stepAccessoriesDescription,
    minimum_amount: formValues.minimumAmount,
    maximum_amount: formValues.maximumAmount,
    cover_amount: formValues.coverAmount,
    is_manager_approval_required: formValues.isManagerApprovalRequired,
    is_custom_address_activated: formValues.isCustomAddressActivated,
    has_vat: formValues.hasVat,
    is_asset_return_required: formValues.isAssetReturnRequired ? 1 : 0,
    is_active: formValues.isActive,
    is_buyout_allowed: formValues.isBuyoutAllowed,
    payment_interval: formValues.paymentInterval,
    cover_interval: formValues.coverInterval,
    order_interval: formValues.orderInterval,
    cover_amount_init: formValues.coverAmountInit,
    is_relations_ignored: formValues.isRelationsIgnored ? 1 : 0,
    is_admin_restricted: isAdmin ? (formValues.isAdminRestricted ? 1 : 0) : undefined,
    admin_overwrite_user_id: isAdmin ? formValues.adminOverwriteUserId || null : undefined,
    greenpool_type_id: formValues.greenpoolTypeId || null,
    greenpool_confirmation_text: formValues.greenpoolConfirmationText || null,
    greenpool_splash_text: formValues.greenpoolSplashText || null,
    greenpool_notification_email: formValues.greenpoolNotificationEmail || null,
    is_manager_accessible: formValues.isManagerAccessible,
    is_leasing: formValues.isLeasing ? 1 : 0,
    step_greenpool_description: formValues.stepGreenpoolDescription || null,
  }

  if (!isAdmin) delete payload.is_admin_restricted
  if (!isAdmin) delete payload.admin_overwrite_user_id

  return payload
}
